import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import 'semantic-ui-css/semantic.min.css'
import 'katex/dist/katex.min.css'
import 'prismjs/themes/prism.css'
import 'prismjs/plugins/line-numbers/prism-line-numbers.css'
import '../styles/code.css'
import { Meta } from './Meta'
import { css } from 'emotion'
import { Header as defaultHeader } from './Header'
import { Footer } from './Footer'
import { GoogleAnalytics } from './GoogleAnalytics'

export const LINK_LIST_CONTAINER_WIDTH = `980px`

export const styles = {}
styles.wrapper = css`
  /* Font resize styles - readable */
  font-size: 1.5em;
  h1 { font-size: 2em; }
  .container h1 { font-size: 1.5em; }
  min-height: 100vh;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  .page-content {
    display: flex;
    justify-content: space-between;
    @media (max-width: ${LINK_LIST_CONTAINER_WIDTH}) {
      padding-top: 16px;
      display: block;
    }
    .side-bar {
      @media (max-width: ${LINK_LIST_CONTAINER_WIDTH}) {
        display: none;
      }
    }
    .center-bar {
      @media (max-width: ${LINK_LIST_CONTAINER_WIDTH}) {
        margin: 0;
      }
      padding: 0px 1.0875rem 1.45rem;
      padding-top: 0;
      margin: 32px;
      max-width: ${LINK_LIST_CONTAINER_WIDTH};
    }
  }
`

export const Layout = ({
  left,
  right,
  active,
  image,
  children,
  meta: extraMeta,
  title: extTitle,
  header: Header = defaultHeader,
}) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          meta: siteMetadata {
            title {
              short
              full
            }
          }
        }
      }
    `}
    render={({ site: { meta } }) => {
      const title = extTitle || meta.title.full
      return (
        <div className={styles.wrapper}>
          <GoogleAnalytics />
          <Meta title={title} extra={extraMeta} />
          <Header {...{ title, image, active }} />
          <div className="page-content">
            <div className="side-bar">{left}</div>
            <div className="center-bar">{children}</div>
            <div className="side-bar">{right}</div>
          </div>
          <Footer />
        </div>
      )
    }}
  />
)
